import React from 'react';
import classNames from 'classnames';

import './styles.css';

export default class Navigation extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      mobileVisible: false,
    }
  }

  showMobileMenu = () => {
    this.setState({
      mobileVisible: true,
    })
    document.body.className = 'no-scroll';
  }

  hideMobileMenu = () => {
    this.setState({
      mobileVisible: false,
    })
    document.body.className = '';
  }

  scrollToAbout = () => {
    this.hideMobileMenu()
    this.props.scrollTo('about')
  }

  scrollToMap = () => {
    this.hideMobileMenu()
    this.props.scrollTo('map')
  }

  scrollToContact = () => {
    this.hideMobileMenu()
    this.props.scrollTo('contact')
  }

  render() {
    const { mobileVisible } = this.state

    const mobileMenuClasses = classNames({
      'Nav-mobile-menu': true,
      'Nav-mobile-menu__visible': mobileVisible,
    })

    return (
      <div className="Nav" ref="navigation">
        <div className="Nav-logo"></div>
        <div className="Nav-items visible-desktop">
          <a onClick={this.scrollToAbout} className="Nav-item">Fyrirtækið</a>
          <a onClick={this.scrollToMap} className="Nav-item">Staðsetning</a>
          <a onClick={this.scrollToContact} className="Nav-item">Hafa samband</a>
        </div>
        <button className="Nav-toggle-menu visible-mobile no-button-styles" onClick={this.showMobileMenu}>
          <i className="Nav-menu-button"></i>
        </button>
        <div className={mobileMenuClasses}>
          <button className="Nav-close-mobile no-button-styles" onClick={this.hideMobileMenu}>
            <i className="Nav-mobile-menu-close"></i>
          </button>
          <a onClick={this.scrollToAbout} className="Nav-mobile-item">Fyrirtækið</a>
          <a onClick={this.scrollToMap} className="Nav-mobile-item">Staðsetning</a>
          <a onClick={this.scrollToContact} className="Nav-mobile-item">Hafa samband</a>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/navigation/index.js